import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../shared';

import { ArticlesService } from '../shared';
import { ArticleComponent } from './article.component';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@NgModule({
  imports: [ SharedModule, CollapseModule ],
  declarations: [
    ArticleComponent
   ],
  providers: [ ArticlesService, BsModalService ]
})

export class ArticleModule {}



// WEBPACK FOOTER //
// ./src/app/article/article.module.ts